const INIT = 'INIT';

const FULL = 'FULL';

const DYNAMIC = 'DYNAMIC';

export const FETCH_DATA_TYPE = {
  INIT,
  FULL,
  DYNAMIC,
};

export default {};
